import axios from "axios";
import { useTranslation } from "TranslationContext";
import {
  getAuthToken,
  getUserLanguage,
} from "./local-storage";
import apiHelper, { apiExternalHelper } from "services/apiHelper";
import { countryToLanguageMap, dayTranslations, monthTranslations } from "configs/common";
import { setUserLanguage } from "utils/local-storage";
import CustomToast from "components/CustomToast";
import JSZip from 'jszip';
import { useEffect, useState } from "react";
import { DATE } from "configs/brandConfig";
import moment from "moment";
export const isObject = (value) => {
  const type = typeof value;
  return value != null && (type === "object" || type === "function");
};

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const markStates = (sobj, self) => {
  if (!isObject(sobj)) {
    throw new Error("mark: invalid sobj, exepect a object");
  }
  const selfKeys = Object.keys(self);

  Object.entries(sobj).forEach(([key, val]) => {
    if (!selfKeys.includes(key)) return false;
    if (!Array.isArray(val) && isObject(val) && self[key] !== null) {
      // eslint-disable-next-line no-param-reassign
      self[key] = Object.assign(self[key], val);
    } else {
      // eslint-disable-next-line no-param-reassign
      self = Object.assign(self, { [key]: val });
    }
  });

  return false;
};

export function NumberToTime(duration) {
  const hour = Math.floor(duration / 60 / 60);
  const minute = Math.floor((duration - hour * 60 * 60) / 60);
  return `${hour === 0 ? "00" : hour < 10 ? `0${hour}` : hour}:${minute === 0 ? "00" : minute < 10 ? `0${minute}` : minute
    }`;
}

export function NumberToTimeText(duration) {
  const now = Date.now();
  const remainigTime = now - duration;
  const remainDays = Math.floor(remainigTime / (24 * 60 * 60 * 1000));
  const remainDaysInSeconds = remainDays * 24 * 60 * 60 * 1000;
  const remainHours = Math.floor(
    (remainigTime - remainDaysInSeconds) / (60 * 60 * 1000)
  );
  const remainHoursInSeconds = remainHours * 60 * 60 * 1000;
  const remainMinutes = Math.floor(
    (remainigTime - (remainDaysInSeconds + remainHoursInSeconds)) / (60 * 1000)
  );
  // const remainMinutesInSeconds = remainMinutes * 60 * 1000;
  // const remainSeconds = Math.floor(
  //   (remainigTime -
  //     (remainDaysInSeconds + remainHoursInSeconds + remainMinutesInSeconds)) /
  //   1000
  // );

  return `${remainDays === 0
    ? ""
    : remainDays < 10
      ? `0${remainDays} Days,`
      : `${remainDays} Days,`
    }  ${remainHours === 0
      ? ""
      : remainHours < 10
        ? `0${remainHours} Hours,`
        : `${remainHours} Hours,`
    } ${remainMinutes === 0
      ? ""
      : remainMinutes < 10
        ? `0${remainMinutes} Minute`
        : `${remainMinutes} Minute`
    } `;
}

export function TimeToNumber(time) {
  const hour = time.substring(0, 2);
  const minute = time.substring(3, 5);
  return hour * 60 * 60 + minute * 60;
}

export function generateDatabaseDateTime(date) {
  if (date === "0") {
    return "0";
  }

  const p = new Intl.DateTimeFormat("pl", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    // timeZone: "GMT",
  })
    .formatToParts(date)
    .reduce(
      (acc, part) => {
        acc[part.type] = part.value;
        return acc;
      },
      {
        year: undefined,
        month: undefined,
        day: undefined,
        hour: undefined,
        minute: undefined,
        second: undefined,
      }
    );

  return `${p.day}/${p.month}/${p.year} ${p.hour}:${p.minute}:${p.second}`;
}
export function generateDatabaseDateTimeWithSecond(date) {
  const p = new Intl.DateTimeFormat("pl", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    timeZone: "GMT",
  })
    .formatToParts(date)
    .reduce(
      (acc, part) => {
        acc[part.type] = part.value;
        return acc;
      },
      {
        year: undefined,
        month: undefined,
        day: undefined,
        hour: undefined,
        minute: undefined,
        second: undefined,
      }
    );

  return `${p.day} ${p.month} ${p.year} ${p.hour}:${p.minute}:${p.second}`;
}

export function postScheduleTimeToDate(date) {
  const p = new Intl.DateTimeFormat("pl", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    // timeZone: "GMT",
  })
    .formatToParts(date)
    .reduce(
      (acc, part) => {
        acc[part.type] = part.value;
        return acc;
      },
      {
        year: undefined,
        month: undefined,
        day: undefined,
        hour: undefined,
        minute: undefined,
        second: undefined,
      }
    );
  return `${p.month}/${p.day}/${p.year} ${p.hour}:${p.minute}`;
}

export function generateDatabaseDate(date) {
  const p = new Intl.DateTimeFormat("pl", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  })
    .formatToParts(date)
    .reduce(
      (acc, part) => {
        acc[part.type] = part.value;
        return acc;
      },
      {
        year: undefined,
        month: undefined,
        day: undefined,
        hour: undefined,
        minute: undefined,
        second: undefined,
      }
    );
  if(DATE.IS_DAY_FIRST){
    return `${p.day}/${p.month}/${p.year} ${p.hour}:${p.minute}:${p.second}`;
  }else{
    return `${p.month}/${p.day}/${p.year} ${p.hour}:${p.minute}:${p.second}`;
  }
}

export function generateDate(timestamp) {
  try {
    const strTimestamp = String(timestamp);
    const truncatedTimestamp = strTimestamp.slice(0, 13); // Take first 13 digits
    const date = new Date(Number(truncatedTimestamp));
  
    // If date is invalid, use current date instead
    if (isNaN(date.getTime())) {
      return formatCurrentDate();
    }
  
    const p = new Intl.DateTimeFormat("en", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    })
    .formatToParts(date)
    .reduce(
      (acc, part) => {
        acc[part.type] = part.value;
        return acc;
      },
      {
        year: undefined,
        month: undefined,
        day: undefined,
        hour: undefined,
        minute: undefined,
        second: undefined,
      }
    );
  if(DATE.IS_DAY_FIRST){
    return `${p.day}/${p.month}/${p.year}`;
  }else{
    return `${p.month}/${p.day}/${p.year}`;
  }
  } catch (error) {
    console.error("Error formatting date:", error);
    return formatCurrentDate(); // Fallback to current date
  }
}
 
export function accurateTime(timestamp) {
  try {
    const strTimestamp = String(timestamp);
    const truncatedTimestamp = strTimestamp.slice(0, 13);
    const date = new Date(Number(truncatedTimestamp));
  
    if (isNaN(date.getTime())) {
      return moment().format("hh:mm A"); // Fallback to current time
    }
    return moment(date).format("hh:mm A");
  } catch (error) {
    console.error("Error formatting time:", error);
    return moment().format("hh:mm A"); // Fallback to current time
  }
}
 
// Helper function to return current date in "MM/DD/YYYY" format
function formatCurrentDate() {
  const now = new Date();
  const p = new Intl.DateTimeFormat("en", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(now).reduce((acc, part) => {
    acc[part.type] = part.value;
    return acc;
  }, {});
  return `${p.month}/${p.day}/${p.year}`;
}

export function generateTime(date) {
  const p = new Intl.DateTimeFormat("pl", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  })
    .formatToParts(date)
    .reduce(
      (acc, part) => {
        acc[part.type] = part.value;
        return acc;
      },
      {
        year: undefined,
        month: undefined,
        day: undefined,
        hour: undefined,
        minute: undefined,
        second: undefined,
      }
    );

  return `${p.hour}:${p.minute}`;
}

export function lastLocationTime(date) {
  const p = new Intl.DateTimeFormat("pl", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  })
    .formatToParts(date)
    .reduce(
      (acc, part) => {
        acc[part.type] = part.value;
        return acc;
      },
      {
        year: undefined,
        month: undefined,
        day: undefined,
        hour: undefined,
        minute: undefined,
        second: undefined,
      }
    );
  return `${p.hour}:${p.minute}:${p.second}`;
}

export function isYesterday(date) {
  const inputDate = new Date(date);
  if (!(inputDate instanceof Date)) {
    throw new Error("Date is wrong");
  }
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  return (
    inputDate.getDate() === yesterday.getDate() &&
    inputDate.getMonth() === yesterday.getMonth() &&
    inputDate.getFullYear() === yesterday.getFullYear()
  );
}

export function isToday(date) {
  const inputDate = new Date(date);
  if (!(inputDate instanceof Date)) {
    throw new Error("Date is wrong");
  }
  const today = new Date();
  today.setDate(today.getDate());

  return (
    inputDate.getDate() === today.getDate() &&
    inputDate.getMonth() === today.getMonth() &&
    inputDate.getFullYear() === today.getFullYear()
  );
}

export function chatTiming(timestamp) {
  if (isYesterday(timestamp)) {
    return "yesterday";
  }
  const p = new Intl.DateTimeFormat("pl", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    timeZone: "GMT",
  })
    .formatToParts(timestamp)
    .reduce(
      (acc, part) => {
        acc[part.type] = part.value;
        return acc;
      },
      {
        year: undefined,
        month: undefined,
        day: undefined,
        hour: undefined,
        minute: undefined,
        second: undefined,
      }
    );
  if (isToday(timestamp)) {
    return `${p.hour}:${p.minute}`;
  } else {
    return `${p.day}/${p.month}/${p.year}`;
  }
}

export function formattedTime(secondsToHm) {
  var d = Number(secondsToHm);
  var h = Math.floor(d / 3600);
  var m = Math.floor((d % 3600) / 60);
  var s = Math.floor((d % 3600) % 60);
  //m = s > 0 ? m + 1 : m;

  var hDisplay = h > 0 ? h + "h " : "";
  var mDisplay = m > 0 ? m + (h > 0 ? "m" : "m") : "";
  var sDisplay = h === 0 && m === 0 && s > 0 ? "1m" : "";

  return hDisplay + mDisplay + sDisplay;
}

export function getSearchEngineMarketid(searchengine){
  if("Google"===searchengine)
    return "com.google.android.googlequicksearchbox";
  if("Yahoo"===searchengine)
    return "com.yahoo.mobile.client.android.search";
  if("Bing"===searchengine)
    return "com.microsoft.bingintl";
  if("Duckduckgo"===searchengine)
    return "com.duckduckgo.mobile.android";
  if("Youtube"===searchengine)
    return "com.google.android.youtube";
  return searchengine;
}

export const formatTime = (seconds) => {
  const hrs = String(Math.floor(seconds / 3600)).padStart(2, "0");
  const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
  const secs = String(seconds % 60).padStart(2, "0");
  if (hrs > 0) {
    return `${String(hrs).padStart(2, "0")}:${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  } else {
    return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  }
};

export const getDateString = (daysbefore) => {
  const date = new Date();
  date.setDate(date.getDate() - daysbefore); // Adjust the date based on daysbefore

  const formattedDate = date
    .toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
    })
    .replace(/(\w)(\w*)/, (match, first, rest) => first.toUpperCase() + rest.toLowerCase()); // Capitalize first letter

  return formattedDate;
};
export const getPerstange = (totalUsage, appusage) => {
  var per = Math.floor((appusage / totalUsage) * 100);
  return per;
};

export const dataDownload = (imei, appName) => {
  const token = getAuthToken();
  let url = `${getAPIURL()}api/dataliberation/download/${imei}/${appName}`;
  axios({
    url: url,
    method: "GET",
    responseType: "blob", // Set the response type to blob
    headers: {
      Authorization: `Bearer ${token}`, // Add the token to the Authorization header
    },
    // Optionally, you can send parameters in the query string if required by your API
    // Example: params: { fileId: 123 }
  })
    .then((response) => {
      // Create a temporary URL for the blob
      const url = window.URL.createObjectURL(new Blob([response.data]));
      // Create a temporary anchor element
      const a = document.createElement("a");
      a.href = url;
      // Specify the file name
      a.download = appName+".zip"; // Change to your desired filename
      // Append the anchor element to the document body
      document.body.appendChild(a);
      // Trigger the click event to initiate download
      a.click();
      // Remove the anchor element
      window.URL.revokeObjectURL(url);
    })
    .catch((error) => {
      console.error("There was an error!", error);
    });
};

export const livePanelDataDownload = async (accessurl) => {
  const token = getAuthToken();
  try {
      const response = await fetch(accessurl, {
          method: "GET",
          headers: {
              Authorization: `Bearer ${token}`,
          },
      });

      if (!response.ok) throw new Error("Network response was not ok");

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      // Extract filename from the URL's "filename" query parameter
      const urlObj = new URL(accessurl);
      const filenameParam = urlObj.searchParams.get("filename");
      let filename = filenameParam ? filenameParam.split("/").pop() : "downloaded_file";

      // Create a temporary <a> element to trigger the download
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename; // Use extracted filename
      document.body.appendChild(link);
      link.click();
      try {
        if (document.body.contains(link)) {
          document.body.removeChild(link);
        }
      } catch (err) {
        console.error("Error removing anchor element:", err);
      }
      // Revoke blob URL after download
      window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
      console.error("Download failed:", error);
  }
};

export const allDataDownload = (imei) => {
  const token = getAuthToken();
  let url = `${getAPIURL()}api/dataliberation/download/all/${imei}`;
  axios({
    url: url,
    method: "GET",
    responseType: "blob", // Set the response type to blob
    headers: {
      Authorization: `Bearer ${token}`, // Add the token to the Authorization header
    },
    // Optionally, you can send parameters in the query string if required by your API
    // Example: params: { fileId: 123 }
  })
    .then((response) => {
      // Create a temporary URL for the blob
      const url = window.URL.createObjectURL(new Blob([response.data]));
      // Create a temporary anchor element
      const a = document.createElement("a");
      a.href = url;
      // Specify the file name
      a.download = `${imei}_data.zip`;
      // Append the anchor element to the document body
      document.body.appendChild(a);
      // Trigger the click event to initiate download
      a.click();
      // Remove the anchor element
      window.URL.revokeObjectURL(url);
    })
    .catch((error) => {
      console.error("There was an error!", error);
    });
};

  // Function to add an image to the zip file
  const addToZip = async (zip, imageUrl, index, total, setProgress, setZipBlob, setZipReady, setLoading) => {
  try {
    const token = getAuthToken();

    // step-1: fetch metadata → actual file url
    const metaRes = await fetch(imageUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json'
      }
    });

    if (!metaRes.ok) return zip;
    const { data: fileUrl } = await metaRes.json();
    if (!fileUrl) return zip;

    // step-2: prepare real download request
    let downloadUrl = fileUrl;
    let options = {};

    if (fileUrl.includes('finalurl') && fileUrl.includes('xamzserversideencryption')) {
      const req = buildRequest(fileUrl);
      downloadUrl = req.updatedUrl;
      options.headers = req.headers;
    }

    const fileRes = await fetch(downloadUrl, options);
    if (!fileRes.ok) return zip;

    const blob = await fileRes.blob();

    // step-3: generate filename
    const raw = safeDecodeURIComponent(fileUrl.split('?')[0]);
    const name = raw.substring(raw.lastIndexOf('/') + 1);
    const ts = new Date()
      .toISOString()
      .replace(/[-:]/g, '')
      .replace(/\..+/, '')
      .replace('T', '_');

    const finalName = name.includes('.')
      ? `${name.split('.')[0]}_${ts}.${name.split('.').pop()}`
      : `${name}_${ts}`;

    zip.file(finalName, blob);

    // step-4: progress UI
    const pct = Math.round(((index + 1) / total) * 100);
    setProgress(pct);
    if (pct === 100) setLoading(false);

    return zip;
  } catch (e) {
    console.error('Download error:', e);
    return zip;
  }
};
  
  

 export const handleAllPhotosDownload = async (imageUrls,setProgress,setZipBlob,setZipReady,setLoading) => {
    setLoading(true)
    const zip = new JSZip();
    const totalImages = imageUrls.length;

    try {
      for (let index = 0; index < totalImages; index++) {
        await addToZip(zip, imageUrls[index], index, totalImages,setProgress,setZipBlob,setZipReady,setLoading);
      }

      zip.generateAsync({ type: 'blob'}).then((content) => {
        
        setZipBlob(content);  // This is allowed since we're using the setter
        setZipReady(true);
        
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const yyyy = today.getFullYear();
        const dateString = `${dd}${mm}${yyyy}`;

        // Trigger the download once zip is ready
        const url = URL.createObjectURL(content);
        const link = document.createElement('a');
        
        link.href = url;
        link.download = `images_${dateString}.zip`;
        link.click();  // Start the download
        setLoading(false);
      });
    } catch (error) {
      console.error('Error creating zip:', error);
    }
  };

 
  export const convertPngToJpgBase64 = async (imageUrl) => {
    try {
      // Fetch image from URL
      const response = await fetch(imageUrl);
      if (!response.ok) throw new Error(`Failed to fetch image: ${response.statusText}`);
  
      const blob = await response.blob();
      const img = new Image();
      img.crossOrigin = "Anonymous"; // Prevent CORS issues
  
      // Ensure the image is loaded before processing
      await new Promise((resolve, reject) => {
        img.onload = resolve;
        img.onerror = reject;
        img.src = URL.createObjectURL(blob);
      });
  
      const targetSize = 512;
      const aspectRatio = img.width / img.height;
      const [newWidth, newHeight] = img.width > img.height
        ? [targetSize, targetSize / aspectRatio]
        : [targetSize * aspectRatio, targetSize];
  
      // **Dynamically resize canvas to prevent unnecessary white padding**
      const canvas = document.createElement("canvas");
      canvas.width = newWidth;
      canvas.height = newHeight;
      const ctx = canvas.getContext("2d");
  
      ctx.fillStyle = "white"; // Background color (important for JPG)
      ctx.fillRect(0, 0, newWidth, newHeight);
      ctx.drawImage(img, 0, 0, newWidth, newHeight);
  
      // Convert to JPG with **80% quality** to reduce file size
      return canvas.toDataURL("image/jpeg", 0.95);
    } catch (error) {
      console.error("Error processing image:", error);
      return null;
    }
  };
  
  

// export const saveTokenAndScheduleDeletion = (token) => {
//   // Save the token in localStorage
//   setAuthToken(token);

//   // Set the time after which you want to delete the token (1 hour)
//   //const deletionTime = new Date().getTime() + 60 * 60 * 1000; // 1 hour in milliseconds
//   const deletionTime = new Date().getTime() + 24 * 60 * 60 * 1000; // 24 hours in milliseconds
//   // Schedule the deletion of the token after one hour
//   setTimeout(() => {
//     // Check if the token exists in localStorage before attempting to delete it
//     if (getAuthToken()) {
//       removeAuthToken();
//     }
//   }, deletionTime - new Date().getTime());
// };
// export const saveUserDetailsAndScheduleDeletion = (userDetails) => {
//   // Save the token in localStorage
//   setUserDetails(userDetails);

//   // Set the time after which you want to delete the userDetails (1 hour)
//   const deletionTime = new Date().getTime() + 60 * 60 * 1000; // 1 hour in milliseconds

//   // Schedule the deletion of the userDetails after one hour
//   setTimeout(() => {
//     // Check if the token exists in localStorage before attempting to delete it
//     if (getUserDetails()) {
//       removeUserDetails();
//     }
//   }, deletionTime - new Date().getTime());
// };

export const getReadableTime =(lasteventtime) => {
  const ms =  Date.now() - lasteventtime;
  if (ms <= 0) {
      return "0 Days, 0 Hours, 0 Minutes";
  }

  let seconds, minutes, hours, days;
  let x = Math.floor(ms / 1000); // Convert milliseconds to seconds
  seconds = x % 60;
  x = Math.floor(x / 60); // Convert seconds to minutes
  minutes = x % 60;
  x = Math.floor(x / 60); // Convert minutes to hours
  hours = x % 24;
  x = Math.floor(x / 24); // Convert hours to days
  days = x;

  return (days > 0 ? days + " Days, " : "") + hours + " Hours, " + minutes + " Minutes";
}

export const differenceDaysHoursMinutesSeconds = (time) => {
  const now = Date.now();
  const remainigTime = Math.abs(time - now);
  const remainDays = Math.floor(remainigTime / (24 * 60 * 60 * 1000));
  const remainDaysInSeconds = remainDays * 24 * 60 * 60 * 1000;
  const remainHours = Math.floor(
    (remainigTime - remainDaysInSeconds) / (60 * 60 * 1000)
  );
  const remainHoursInSeconds = remainHours * 60 * 60 * 1000;
  const remainMinutes = Math.floor(
    (remainigTime - (remainDaysInSeconds + remainHoursInSeconds)) / (60 * 1000)
  );
  const remainMinutesInSeconds = remainMinutes * 60 * 1000;
  const remainSeconds = Math.floor(
    (remainigTime -
      (remainDaysInSeconds + remainHoursInSeconds + remainMinutesInSeconds)) /
    1000
  );
  return { remainDays, remainHours, remainMinutes, remainSeconds };
};

export const categoryNameConvertToDisplayName = (cat) => {
  let category = cat;
  if (cat === "drug") {
    category = "Drugs/Alcohol";
  } else if (cat === "bullying") {
    category = "Bullying";
  } else if (cat === "violence") {
    category = "Violence";
  } else if (cat === "sexting" || cat === "nudity") {
    category = "Sexting/Nudity";
  } else {
    try {
      category = JSON.parse(category); // Parse the JSON string
    } catch (error) {
      console.error("Invalid JSON format", error);
      return category;
    }
  
    // Extract "cat" values from "data"
    category = [
      ...category.data.map((item) => item.cat),
    ];
  }
  return category;
};

export const categoryNameConvertToTimeline = (cat) => {
  if (!cat || typeof cat !== "string") return ""; // Handle empty or non-string values
  
  // Predefined category mappings
  const categoryMappings = {
    drug: "Drugs/Alcohol",
    bullying: "Bullying",
    violence: "Violence",
    sexting: "Sexting/Nudity",
    nudity: "Sexting/Nudity",
  };

  // Check if category is in predefined mappings
  if (categoryMappings[cat]) return categoryMappings[cat];

  // Function to check if a string is valid JSON
  const isValidJson = (str) => {
    try {
      const parsed = JSON.parse(str);
      return parsed && typeof parsed === "object"; // Ensure it's a valid object
    } catch (error) {
      return false;
    }
  };

  // Parse JSON if valid
  if (isValidJson(cat)) {
    const parsedData = JSON.parse(cat);
    return parsedData.data ? parsedData.data.map((item) => item.cat).join(", ") : cat;
  }

  return cat; // Return original string if not JSON
};

export const loadScript = (src) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => resolve(script);
    script.onerror = () => reject(new Error(`Script load error for ${src}`));
    document.head.appendChild(script);
  });
};

// export const getMediaURL = async (url, imei,type) => {

//   // const splitedUrl = url.split("?")[1]?.split("&")?.slice(1)?.join("&");
//   const newUrl = `api/files/downloadfile/${imei}?` + url.split("?")[1]+ `&type=${type}`;

//   return await apiHelper(newUrl, "get", {}, {});
// };

export const getMediaURL = async (url, imei, type) => {
    const newUrl = `api/files/downloadfile/${imei}?` + url.split("?")[1] + `&type=${type}`;
    const res = await apiHelper(newUrl, "get", {}, {});
    const fileUrl = res.data.data;

    if (!fileUrl) throw new Error("No file URL returned");

    //TO do check mp4 why this code added
    // if (fileUrl.toLowerCase().includes(".mp4")) {
    //   return { data: { data: fileUrl } };
    // }

    const fileName = decodeURIComponent(fileUrl.split("?")[0].split("/").pop());

    if (fileUrl.includes("finalurl") && fileUrl.includes("xamzserversideencryption")) {
      try {
        const { updatedUrl, headers } = buildRequest(fileUrl);
        const response = await fetch(updatedUrl, { headers });

        if (!response.ok) throw new Error(`Failed to fetch file: ${response.status}`);

        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        return { data: { data: objectUrl, filename: fileName } };
      } catch (s3Error) {
        console.warn("S3 direct fetch failed, falling back to backend:", s3Error);
        return { data: { data: fileUrl, filename: fileName } };
      }
    }

    return { data: { data: fileUrl, filename: fileName } };
};





export const ScheduleDataDownload = async (fileUrl, suggestedName) => {
  if (fileUrl) {
    // Fetch the file as a Blob
    const response = await fetch(fileUrl);
  
    // Determine the file extension from Content-Type or URL
    const contentType = response.headers.get("Content-Type");
    const urlParts = fileUrl.split("?");
    const cleanUrl = urlParts[0]; // remove query params if any
  
    // Try to extract filename from URL or fallback
    // Prefer the caller's name: a blob: URL's last segment is a random id
    const fallbackName = suggestedName || cleanUrl.split("/").pop() || "downloaded-file";
    const extensionFromContentType = contentType?.split("/")[1] || "";
    const hasExtension = fallbackName.includes(".");
    const filename = hasExtension ? fallbackName : `${fallbackName}.${extensionFromContentType}`;

    // Don't save an error body (e.g. S3 403 XML) as the file; report which file failed
    if (!response.ok) throw new Error(`Failed to download "${filename}": ${response.status}`);
    const blob = await response.blob();
  
    // Create object URL and download
    const blobURL = URL.createObjectURL(blob);
  
    // Trigger download (optional — remove this block if you only want to return)
    const a = document.createElement("a");
    a.href = blobURL;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  
    // Return the blob URL
    return blobURL;
  } else {
    console.error("Media URL is invalid.");
    return null;
  }
}
export const TranslateWithSpecialCharacters = (text) => {
  const { translate } = useTranslation();
  const combinedPattern = /(\d+|[./~`!])/g;
  const parts = text.split(combinedPattern);
  const translatedParts = parts.map((part) => translate[part.trim()] || part);
  // Reconstruct the string by joining translated parts
  return translatedParts.join(" ");
};

export const getLanguageForCountry = (countrycode, setLocale) => {
  const getlanguagecode = countryToLanguageMap[countrycode] || "pl";
  setUserLanguage(getlanguagecode);
  setLocale(getlanguagecode);
};

export const handleDeleteSelected = (
  type,
  selectedRows,
  currentDevice,
  deleteAllApi,
  mutate,
  toast,
  setSelectedData,
  setDeleteAll,
  onDeleteModalClose
) => {
  if (!Array.isArray(selectedRows) || selectedRows.length === 0) {
    toast({
      position: "top-right",
      status: "error",
      render: () => (
        <CustomToast
          bgColor={"red"}
          message="No items selected. Please select rows to delete."
        />
      ),
    });
    return;
  }
  deleteAllApi(type, currentDevice, selectedRows)
    .then((res) => {
      if (type !== "dataliberation") {
        mutate();
      }
      toast({
        position: "top-right",
        status: "success",
        render: () => <CustomToast message={res.data.message} />,
      });
      if (type === "dataliberation") {
        setSelectedData([]);
        setDeleteAll(false);
      }
      if (onDeleteModalClose) {
        onDeleteModalClose();
      }
    })
    .catch((err) => {
      console.error(err);;
      toast({
        position: "top-right",
        status: "error",
        render: () => (
          <CustomToast
            bgColor={"red"}
            message={err.response?.data?.message || "An error occurred."}
          />
        ),
      });
    });
};

export function getPersantage(totalUsage, appUsage) {
  var per = (appUsage / totalUsage) * 100;
  return per.toFixed(0);
}

export function getAPIURL() {
  return process.env.REACT_APP_API_URL;
}

// decodeURIComponent throws URIError ("URI malformed") on input with stray
// `%` sequences — common in agent-supplied data (filenames, contact names,
// SSIDs, market IDs). Wrap with try/catch so a single bad string doesn't
// crash the whole component. Non-string and null/undefined inputs short-
// circuit to "" so callers can safely concatenate or render.
export const safeDecodeURIComponent = (input) => {
  if (input == null) return "";
  if (typeof input !== "string") return input;
  try { return decodeURIComponent(input); } catch { return input; }
};

export function replaceHostname(oldUrl) {
  return oldUrl;
}
  
export function getCurrentTimeInTimeZone(timeZone) {
  const now = new Date();
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone,
    weekday: 'long',
    hour: 'numeric',
    minute: 'numeric',
    hour12: false,
  });
  const parts = formatter.formatToParts(now);
  const timeParts = {};
  parts.forEach(({ type, value }) => {
    timeParts[type] = value;
  });
  return timeParts;
}

// Get the current time in IST

export const openVideotab = async (getfetchurl) => {
  try {
    if (getfetchurl) {
      const videoWindow = window.open("", "_blank");
      videoWindow.document.write(`
             <div text-align="center">
            <video controls autoplay muted width="500px" height="500px">
          <source src="${getfetchurl}" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        </div>
        `);
      videoWindow.document.close(); // To make sure the content is properly loaded 
    }
  } catch (error) {
    console.error("Error fetching media URL:", error);  // Handle errors
  }

};



export const UploadUrl = async (uploadUrl, ackUrl, blobData, contentType = "application/octet-stream") => {
  const token = getAuthToken();
  try {
      // Create blob if not already created (for backward compatibility)
      const blob = blobData instanceof Blob 
          ? blobData 
          : new Blob([blobData], { type: contentType });

      // Step 1: Upload Blob to S3 using PUT
      await apiExternalHelper(uploadUrl, blob, "put", {
          headers: {
              "Content-Type": blob.type || contentType,
          },
      });

      // Step 2: Send Acknowledgment if needed
      const finalAckUrl = ackUrl.replace("<iFilesize>", blob.size.toString());

      await apiExternalHelper(finalAckUrl, null, "get", {
          headers: {
              Authorization: `Bearer ${token}`,
          },
      });

      console.log("Ack sent successfully!");
  } catch (error) {
      console.error("Upload failed:", error);
  }
};

export function formatDuration  (totalSeconds)  {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const paddedSeconds = seconds.toString().padStart(2, '0');
  const paddedMinutes = minutes.toString();

  if (hours > 0) {
    return `${hours}:${paddedMinutes.padStart(2, '0')}:${paddedSeconds}`;
  } else {
    return `${minutes}:${paddedSeconds}`;
  }
};

export const formatDate = (timestamp) => {
  // Handle cases where timestamp might be undefined
  const languageMode = getUserLanguage();
  
  if (!timestamp) return "Invalid Date";
  
  // Convert to Date object - handle both milliseconds and string formats
  const dateObject = new Date(
    typeof timestamp === 'string' ? 
    timestamp.includes('T') ? timestamp : Number(timestamp) 
    : timestamp
  );
  
  // Validate the date
  if (isNaN(dateObject.getTime())) {
    console.error("Invalid timestamp:", timestamp);
    return "Invalid Date";
  }

  const months = monthTranslations[languageMode] || monthTranslations.en;
  const dayTexts = dayTranslations[languageMode] || dayTranslations.en;
  const now = new Date();
  
  // Compare dates (ignoring time)
  const isToday = dateObject.toDateString() === now.toDateString();
  const isYesterday = (() => {
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    return dateObject.toDateString() === yesterday.toDateString();
  })();

  // if (isToday) return "Today";
  // if (isYesterday) return "Yesterday";

  if (isToday) return dayTexts.today;
  if (isYesterday) return dayTexts.yesterday;
  
  return `${dateObject.getDate()} ${months[dateObject.getMonth()]} ${dateObject.getFullYear()}`;
};

// export const useDeviceDetection = () => {
//   const [deviceInfo, setDeviceInfo] = useState({
//     isDesktop: !!navigator.maxTouchPoints ? 'mobile' : 'computer',
//     orientation: !navigator.maxTouchPoints 
//       ? 'desktop' 
//       : !window.screen.orientation.angle 
//         ? 'portrait' 
//         : 'landscape'
//   });

//   useEffect(() => {
//     function handleResize() {
//       setDeviceInfo({
//         isDesktop: !!navigator.maxTouchPoints ? 'mobile' : 'computer',
//         orientation: !navigator.maxTouchPoints 
//           ? 'desktop' 
//           : !window.screen.orientation.angle 
//             ? 'portrait' 
//             : 'landscape'
//       });
//     }

//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   return deviceInfo;
// }

export const useDeviceDetection = () => {
  const [deviceInfo, setDeviceInfo] = useState(() => {
    // Check if window is available (for SSR)
    const isClient = typeof window !== 'undefined';
    
    // Default values for SSR or unsupported browsers
    if (!isClient) {
      return {
        isDesktop: 'computer',
        orientation: 'desktop'
      };
    }

    // Check for touch device
    const isMobile = !!navigator.maxTouchPoints;
    
    // Safely check orientation
    let orientation = 'desktop';
    if (isMobile && window.screen.orientation) {
      orientation = window.screen.orientation.angle === 0 ? 'portrait' : 'landscape';
    }

    return {
      isDesktop: isMobile ? 'mobile' : 'computer',
      orientation
    };
  });

  useEffect(() => {
    function handleResize() {
      const isMobile = !!navigator.maxTouchPoints;
      
      let orientation = 'desktop';
      if (isMobile && window.screen.orientation) {
        orientation = window.screen.orientation.angle === 0 ? 'portrait' : 'landscape';
      }

      setDeviceInfo({
        isDesktop: isMobile ? 'mobile' : 'computer',
        orientation
      });
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return deviceInfo;
};

// 🔹 helper to build final URL + headers
export const buildRequest = (fileUrl) => {
  const urlObj = new URL(fileUrl);
  const params = new URLSearchParams(urlObj.search);

  const finalHost = params.get("finalurl");
  const cleanPath = urlObj.pathname.replace(/^\/s3/, "");

  const updatedUrl = `https://${finalHost}${cleanPath}?${params.toString()}`;

  const headers = {
    "x-amz-server-side-encryption-customer-algorithm": params.get("xamzserversideencryptioncustomeralgorithm"),
    "x-amz-server-side-encryption-customer-key": decodeURIComponent(params.get("xamzserversideencryptioncustomerkey")),
    "x-amz-server-side-encryption-customer-key-MD5": params.get("xamzserversideencryptioncustomerkeymd5"),
  };

  return { updatedUrl, headers };
};